export default __webpack_public_path__ + "static/media/macbook_mockup_banner.50dff2a3.png";